import React, { useState } from "react";
import Image from "./Image";
import Switch from "../Switch";
import Heroicon from "../Heroicon";

function PodcastResults({ results, selectedPodcast, selectPodcast }) {

    const [showTooltip, setShowTooltip] = useState(false);
    const errors = selectedPodcast && selectedPodcast.errors;

    function handleMouseEnter() {
        setShowTooltip(true);
    }
    function handleMouseLeave() {
        setShowTooltip(false);
    }

    return (
        <ul className={`space-y-2 w-full rounded max-h-96 ${results.length > 1 ? 'overflow-y-auto overflow-x-hidden' : ''}`}>
            {results.map((podcast, index) => (
                <li key={index}>
                    <button 
                        disabled={(selectedPodcast && selectedPodcast.url === podcast.url) && errors ? true : false}
                        className={`w-full flex text-left items-center gap-2 focus:outline-none focus:bg-purple-200 hover:bg-purple-200 transition hover:cursor-pointer rounded-md p-3 ${selectedPodcast && selectedPodcast.url === podcast.url ? "bg-purple-200" : ""}`}
                        onClick={() => selectPodcast(podcast.url, 400)}
                    >
                        <Image key={index} src={podcast.image} className="w-20 h-20" />
                        <div className="relative w-full flex-1 grid grid-cols-[1fr,160px] gap-4">
                            <div>
                                <p className="font-heading text-xl line-clamp-1 text-gray-700 h-max">
                                    {podcast.title}
                                </p>
                                <p className="text-sm text-gray-500 mt-1">
                                    {podcast.episodeCount} episode{podcast.episodeCount !== 1 && "s"}
                                </p>
                            </div>
                            {selectedPodcast && selectedPodcast.url === podcast.url &&
                                <Switch exp={selectedPodcast.status}>
                                    <Heroicon 
                                        case={"validating"} 
                                        icon="o-arrow-path" 
                                        style="w-6 h-6 animate-spin text-gray-400 justify-self-end m-2" 
                                    />
                                    <div case={"invalid"} className="relative inline-block justify-self-end m-2">
                                        <p 
                                            onMouseEnter={handleMouseEnter}
                                            onMouseLeave={handleMouseLeave} 
                                            className="badge badge--danger flex items-center gap-1 text-[13px] w-max h-[max-content]"
                                        >
                                            Invalid feed
                                            <Heroicon 
                                                icon="o-exclamation-circle" 
                                                style="w-5 h-5 text-red-500" 
                                            />    
                                        </p>
                                        <p 
                                            onMouseEnter={handleMouseEnter}
                                            onMouseLeave={handleMouseLeave}
                                            className={`${showTooltip ? 'visible opacity-100 scale-100' : 'invisible opacity-0 scale-95'} transition-all absolute z-30 bg-gray-700 text-white text-center text-sm shadow rounded py-2 px-3 min-w-[160px] right-0 cursor-default`}
                                        >
                                            {errors && selectedPodcast.errors.join(" ")}
                                        </p>
                                    </div>
                                    <p case={"valid"} className="badge badge--success flex items-center gap-1 text-[13px] w-max h-[max-content] justify-self-end m-2">
                                        Valid feed
                                        <Heroicon 
                                            icon="o-check-circle" 
                                            style="w-5 h-5 text-green-600" 
                                        />
                                    </p>
                                </Switch>
                            }
                        </div>
                    </button>
                </li>
            ))
            } 
        </ul>
    )
}

export default PodcastResults;